import {IQuestion} from '../types';
import {FC, useState} from 'react';
import QuestionCard from './Questions/QuestionCard';
import FormEditQuestion from '../AddQuestion/FormQuestion/FormEditQuestion';

interface IProps {
  index: number;
  question: IQuestion;
}

const QuestionIntercessor: FC<IProps> = ({question, index}) => {
  const [isShowFormEditQuestion, setIsShowFormEditQuestion] = useState(false);

  const handleChangeQuestion = () => {
    setIsShowFormEditQuestion(!isShowFormEditQuestion);
  };

  return isShowFormEditQuestion ? (
    <FormEditQuestion id={question.ID} handleChangeQuestion={handleChangeQuestion} />
  ) : (
    <QuestionCard index={index} question={question} handleChangeQuestion={handleChangeQuestion} />
  );
};
export default QuestionIntercessor;
